import { translate } from '../../../util/translate'

export const paymentFortnightHeaders = [
  {
    text: translate['hausefulInvoices.headers.host'],
    value: 'host',
  },
  {
    text: translate['hausefulInvoices.total'],
    value: 'host_total',
    align: 'end',
    width: 200,
  },
]

export const pendingInvoiceHeaders = [
  {
    text: translate['hausefulInvoices.customer'],
    value: 'customer.name',
  },
  {
    text: translate['hausefulInvoices.headers.document'],
    value: 'customer',
  },
  {
    text: translate['hausefulInvoices.total'],
    value: 'host_total',
    align: 'end',
    width: 200,
  },
]

export const pendingInvoicesPaymentsHeaders = [
  {
    text: translate['hausefulInvoices.headers.code'],
    value: 'appointment_code',
    width: 100,
  },
  {
    text: translate['hausefulInvoices.headers.createdAt'],
    value: 'created_at',
    width: 150,
  },
  {
    text: translate['hausefulInvoices.headers.description'],
    value: 'description',
  },
  {
    text: translate['hausefulInvoices.headers.paymentType'],
    value: 'payment_type',
    width: 150,
  },
  {
    text: translate['hausefulInvoices.headers.hausefulValue'],
    value: 'hauseful_value',
    align: 'end',
    width: 150,
  },
  {
    text: translate['hausefulInvoices.headers.hostValue'],
    value: 'host_value',
    align: 'end',
    width: 150,
  },
  {
    text: translate['hausefulInvoices.headers.movementValue'],
    value: 'movement_value',
    align: 'end',
    width: 200,
  },
]

export const awaitingApprovalHeaders = [
  {
    text: translate['hausefulInvoices.headers.host'],
    value: 'host.name',
  },
  {
    text: translate['hausefulInvoices.headers.customer'],
    value: 'real_estate.name',
  },
  {
    text: translate['hausefulInvoices.headers.createdAt'],
    value: 'created_at',
    width: 150,
  },
  {
    text: translate['hausefulInvoices.headers.analysis'],
    value: 'invoice_file_analysis',
    width: 200,
    align: 'center',
  },
  {
    text: translate['hausefulInvoices.headers.sender'],
    value: 'sender',
    width: 120,
  },
  {
    text: translate['hausefulInvoices.headers.receiver'],
    value: 'receiver',
    width: 120,
  },
  {
    text: translate['hausefulInvoices.total'],
    value: 'total',
    align: 'end',
    width: 150,
  },
  {
    text: translate['hausefulInvoices.headers.actions'],
    value: 'actions',
    align: 'end',
    width: 100,
  },
]

export const approvedHeaders = [
  {
    text: translate['hausefulInvoices.headers.host'],
    value: 'host.name',
  },
  {
    text: translate['hausefulInvoices.headers.customer'],
    value: 'real_estate.name',
  },
  {
    text: translate['hausefulInvoices.headers.createdAt'],
    value: 'created_at',
    width: 150,
  },
  {
    text: translate['hausefulInvoices.headers.analysis'],
    value: 'invoice_file_analysis',
    width: 200,
    align: 'center',
  },
  {
    text: translate['hausefulInvoices.headers.transferStatus'],
    value: 'transfer',
  },
  {
    text: translate['hausefulInvoices.total'],
    value: 'total',
    align: 'end',
  },
  {
    text: translate['hausefulInvoices.headers.actions'],
    value: 'actions',
    align: 'end',
    width: 100,
  },
]

export const refusedHeaders = [
  {
    text: translate['hausefulInvoices.headers.host'],
    value: 'host.name',
    width: 320,
  },
  {
    text: translate['hausefulInvoices.headers.customer'],
    value: 'real_estate.name',
    width: 320,
  },
  {
    text: translate['hausefulInvoices.headers.createdAt'],
    value: 'created_at',
    width: 150,
  },
  {
    text: translate['hausefulInvoices.headers.analysis'],
    value: 'invoice_file_analysis',
    width: 200,
    align: 'center',
  },
  {
    text: translate['hausefulInvoices.headers.transferStatus'],
    value: 'transfer',
    width: 120,
  },
  {
    text: translate['hausefulInvoices.headers.comment'],
    value: 'comment',
  },
  {
    text: translate['hausefulInvoices.total'],
    value: 'total',
    align: 'end',
    width: 150,
  },
  {
    text: translate['hausefulInvoices.headers.actions'],
    value: 'actions',
    align: 'end',
    width: 100,
  },
]

export const invoiceHeaders = [
  {
    text: translate['hausefulInvoices.headers.code'],
    value: 'appointment_code',
    width: 100,
  },
  {
    text: translate['hausefulInvoices.headers.createdAt'],
    value: 'created_at',
    width: 150,
  },
  {
    text: translate['hausefulInvoices.headers.description'],
    value: 'description',
  },
  {
    text: translate['hausefulInvoices.headers.paymentType'],
    value: 'payment_type',
    width: 200,
  },
  {
    text: translate['hausefulInvoices.headers.value'],
    value: 'total',
    align: 'end',
    width: 200,
  },
]

export const invoiceToPayHeaders = [
  {
    text: translate['hausefulInvoices.headers.host'],
    value: 'host.name',
    width: 300,
  },
  {
    text: translate['hausefulInvoices.headers.value'],
    value: 'total',
    align: 'end',
    width: 150,
  },
]

export const transferHeaders = [
  {
    text: translate['transfer.label.name'],
    value: 'host',
    width: 300,
  },
  {
    text: translate['transfer.label.receiver'],
    value: 'receiver_type',
    width: 100,
  },
  {
    text: translate['transfer.label.createdAt'],
    value: 'created_at',
    width: 150,
  },
  {
    text: translate['transfer.label.status'],
    value: 'status',
    width: 100,
  },
  {
    text: translate['transfer.label.asaasTransferId'],
    value: 'asaas_transfer_id',
    width: 150,
  },
  {
    text: translate['transfer.label.total'],
    value: 'total',
    width: 150,
    align: 'right',
  },
  { value: 'actions', align: 'end', width: 50 },
]
